// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip{position:absolute;background-color:#fff;color:#1c1c1e;border:1px solid #f0f3f5;padding:.5rem 1rem;border-radius:.25rem;font-size:12px;top:45px}.tooltip:after{content:\"\";position:absolute;bottom:100%;left:50%;margin-left:-10px;border-width:5px;border-style:solid;border-color:transparent transparent #f0f3f5 transparent}", ""]);
// Exports
module.exports = exports;
